export const AccessProfile = {
  Colaborador: 'Colaborador',
  GerenteDeProjetos: 'Gerente de projetos',
  GestaoDePessoas: 'Gestão de pessoas',
  Administrador: 'Administrador',
} as const;
export type AccessProfile = typeof AccessProfile[keyof typeof AccessProfile];

export const DevProfile = {
  Design: 'Design',
  Desenvolvimento: 'Desenvolvimento',
  Testes: 'Testes',
  GerenteDeProjetos: 'Gerente de projetos',
} as const;
export type DevProfile = typeof DevProfile[keyof typeof DevProfile];

export const UserStatus = {
  Ativo: 'Ativo',
  Inativo: 'Inativo',
} as const;
export type UserStatus = typeof UserStatus[keyof typeof UserStatus];

export interface User {
  id: string;
  name: string;
  email: string;
  emailGmail?: string;
  role: string;
  devProfile?: DevProfile;
  hourlyRate: number;
  accessProfile: AccessProfile;
  status: UserStatus;
  avatar?: string;
  phone?: string;
  birthDate?: string; // YYYY-MM-DD
  admissionDate?: string; // YYYY-MM-DD
  isMaintenanceTeam?: boolean;
  dailyAvailableHours?: number;
}
